import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../../hooks';
import { get as lodashGet, set as lodashSet, keys as lodashKeys } from 'lodash';
import { Capitalize } from '../../../../../utils/stringHelper';
import { toast } from 'react-toastify';
import { AdminInstanceBundleService } from '../../../../../services/BiddingService/Admin/InstanceBundleService';
import allDeviceClasses from '../../../../../styles/AllDevices.module.css';
import bidClasses from '../../Bidding.module.css';
import { FieldArray, Form, Formik } from 'formik';
import { UilMinusCircle, UilPlusCircle } from '@iconscout/react-unicons';
import Dropdown from '../../../../../components/Inputs/Dropdown';
import { Input } from '../../../../../components/Inputs/Input';
import Typography from '../../../../../components/Typography/Typography';
import { InstanceBundleValidation } from '../../../../../validations/BiddingService/Bidding';

export const CreateEditInstanceBundle = ({ data, getInstanceBundle, closeModal }) => {
    const { market = '', rawCustomerData, customers, editBundle = null } = data;
    const [startLoader, stopLoader] = useLoader();

    const [initialValues, setInitialValues] = useState({
        name: editBundle ? editBundle?.label : '',
        pairs: editBundle
            ? editBundle?.pairs.map((item) => ({ licenseId: item.licenseId, instanceId: item.instanceId, customerId: item?.customerId || '' }))
            : [{ licenseId: '', instanceId: '', customerId: '' }],
        market: market,
    });
    const [instanceOptions, setInstanceOption] = useState({});
    const [licenseOptions, setLicenseOption] = useState({});

    useEffect(() => {
        const temp = {};
        for (const el in licenseOptions) {
            const tempLicense = {};
            const licenses = lodashGet(licenseOptions, el, []);
            licenses.map((li) => {
                lodashSet(tempLicense, [li.value], li.instances);
            });
            lodashSet(temp, el, tempLicense);
        }
        setInstanceOption(temp);
    }, [licenseOptions]);

    useEffect(() => {
        const temp = {};
        for (let customerId in rawCustomerData) {
            const customer = lodashGet(rawCustomerData, [customerId]);
            const licenses = customer.licenses;
            const activeLicenses = lodashKeys(licenses).map((id) => ({
                label: Capitalize(licenses[id].type),
                value: id,
                instances: lodashGet(licenses, [id, 'instances'], []).map((ins) => ({ label: ins.name, value: ins._id })),
            }));
            lodashSet(temp, customerId, activeLicenses);
        }
        setLicenseOption((prev) => ({ ...prev, ...temp }));
    }, [rawCustomerData]);

    const handleSubmit = (value) => {
        if (editBundle?.value) AdminInstanceBundleService.UpdateInstanceBundle(editBundle?.value, value, startLoader, handleSuccess, handleError, stopLoader);
        else AdminInstanceBundleService.CreateInstanceBundle(value, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = () => {
        toast.success(`Instance Bundle ${editBundle ? 'updated' : 'created'} successfully`);
        closeModal();
        getInstanceBundle();
    };

    const handleError = (err) => {
        toast.error(lodashGet(err, ['response', 'data', 'message']));
    };

    return (
        <div style={{ width: '30vw', overflow: 'initial' }}>
            <Typography content={`${editBundle ? 'Edit' : 'Create'} Instance Bundle`} />
            <div>
                <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit} validationSchema={InstanceBundleValidation}>
                    {({}) => (
                        <Form>
                            <div>
                                <div className={allDeviceClasses.FieldControl2}>
                                    <label htmlFor="name">
                                        Name
                                        <span className="required">*</span>
                                    </label>
                                    <Input name="name" id="name" />
                                </div>
                            </div>

                            <div>
                                <FieldArray name="pairs">
                                    {({ push, remove, form }) => {
                                        const pairs = form.values.pairs;
                                        return (
                                            <div>
                                                <div>
                                                    {pairs.map((e, index) => (
                                                        <div>
                                                            <div className={allDeviceClasses.InputContainer} key={index}>
                                                                <div className={allDeviceClasses.FieldControl2}>
                                                                    <label htmlFor="customer">
                                                                        Customer <span className="required">*</span>
                                                                    </label>
                                                                    <div>
                                                                        <Dropdown
                                                                            name={`pairs[${index}].customerId`}
                                                                            options={customers}
                                                                            defaultValue={{ value: pairs?.[index]?.customerId || '' }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={allDeviceClasses.InputContainer} key={index}>
                                                                <div className={allDeviceClasses.FieldControl2}>
                                                                    <label htmlFor="license">
                                                                        license <span className="required">*</span>
                                                                    </label>
                                                                    <Dropdown
                                                                        name={`pairs[${index}].licenseId`}
                                                                        options={licenseOptions[pairs[index].customerId]}
                                                                        defaultValue={{ value: pairs?.[index]?.licenseId || '' }}
                                                                    />
                                                                </div>

                                                                <div className={allDeviceClasses.FieldControl2}>
                                                                    <label htmlFor="instance">
                                                                        Instance <span className="required">*</span>
                                                                    </label>
                                                                    <Dropdown
                                                                        name={`pairs[${index}].instanceId`}
                                                                        options={lodashGet(
                                                                            instanceOptions,
                                                                            [lodashGet(pairs, [index, 'customerId']), lodashGet(pairs, [index, 'licenseId'])],
                                                                            []
                                                                        )}
                                                                        defaultValue={{ value: lodashGet(pairs, [index, 'instanceId'], '') }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className={allDeviceClasses.ButtonContainer} style={{ gridColumnGap: '0.2vw' }}>
                                                    {pairs.length > 0 && (
                                                        <span onClick={() => remove(pairs.length - 1)}>
                                                            <UilMinusCircle
                                                                size={'1.5vw'}
                                                                style={{
                                                                    color: 'var(--color-primary)',
                                                                    cursor: 'pointer',
                                                                    zIndex: '1',
                                                                }}
                                                            />
                                                        </span>
                                                    )}
                                                    <span onClick={() => push({ licenseId: '', instanceId: '' })}>
                                                        <UilPlusCircle
                                                            size={'1.5vw'}
                                                            style={{
                                                                color: 'var(--color-primary)',
                                                                cursor: 'pointer',
                                                                zIndex: '1',
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    }}
                                </FieldArray>
                            </div>
                            <div className={allDeviceClasses.ButtonContainer}>
                                <div>
                                    <button type="button" className="btn-secondary" onClick={closeModal}>
                                        Cancel
                                    </button>
                                </div>
                                <div>
                                    <button type="submit" className="btn-primary">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};
